import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

class SMSService {
  constructor() {
    // Configurações padrão do ClickSend (podem ser sobrescritas pelas configurações da empresa)
    this.clicksendConfig = {
      username: 'denis.olvra@gmail.com',
      apiKey: 'C00451E2-7CFE-05AD-2200-F3662041BC63',
      fromName: 'MeuFiel' // Nome que aparecerá como remetente
    };
  }

  // Buscar configurações de SMS da empresa
  async getSMSSettings(companyId) {
    try {
      const companyDoc = await getDoc(doc(db, 'companies', companyId));
      if (companyDoc.exists()) {
        const data = companyDoc.data();
        const smsSettings = data.smsSettings || {};
        
        // Retornar configurações com fallback para padrão
        return {
          enabled: smsSettings.enabled || false,
          clicksendUsername: smsSettings.clicksendUsername || this.clicksendConfig.username,
          clicksendApiKey: smsSettings.clicksendApiKey || this.clicksendConfig.apiKey,
          clicksendFromName: smsSettings.clicksendFromName || this.clicksendConfig.fromName,
          templates: smsSettings.templates || {
            pointsAdded: 'Olá {customerName}! Você ganhou {pointsAdded} pontos na {companyName}. Total: {totalPoints} pontos.',
            pointsRedeemed: 'Olá {customerName}! Você resgatou {pointsRedeemed} pontos na {companyName}. Total restante: {totalPoints} pontos.',
            rewardRedeemed: 'Parabéns {customerName}! Você resgatou: {rewardName} na {companyName}. Pontos restantes: {totalPoints}.',
            birthday: 'Parabéns {customerName}! Hoje você faz {age} anos! 🎉 A {companyName} deseja um feliz aniversário! Você tem {totalPoints} pontos conosco.'
          }
        };
      }
      
      // Se empresa não existe, retornar configurações padrão desabilitadas
      return {
        enabled: false,
        clicksendUsername: this.clicksendConfig.username,
        clicksendApiKey: this.clicksendConfig.apiKey,
        clicksendFromName: this.clicksendConfig.fromName,
        templates: {
          pointsAdded: 'Olá {customerName}! Você ganhou {pointsAdded} pontos na {companyName}. Total: {totalPoints} pontos.',
          pointsRedeemed: 'Olá {customerName}! Você resgatou {pointsRedeemed} pontos na {companyName}. Total restante: {totalPoints} pontos.',
          rewardRedeemed: 'Parabéns {customerName}! Você resgatou: {rewardName} na {companyName}. Pontos restantes: {totalPoints}.',
          birthday: 'Parabéns {customerName}! Hoje você faz {age} anos! 🎉 A {companyName} deseja um feliz aniversário! Você tem {totalPoints} pontos conosco.'
        }
      };
    } catch (error) {
      console.error('Erro ao buscar configurações de SMS:', error);
      // Em caso de erro, retornar configurações padrão desabilitadas
      return {
        enabled: false,
        clicksendUsername: this.clicksendConfig.username,
        clicksendApiKey: this.clicksendConfig.apiKey,
        clicksendFromName: this.clicksendConfig.fromName,
        templates: {
          pointsAdded: 'Olá {customerName}! Você ganhou {pointsAdded} pontos na {companyName}. Total: {totalPoints} pontos.',
          pointsRedeemed: 'Olá {customerName}! Você resgatou {pointsRedeemed} pontos na {companyName}. Total restante: {totalPoints} pontos.',
          rewardRedeemed: 'Parabéns {customerName}! Você resgatou: {rewardName} na {companyName}. Pontos restantes: {totalPoints}.',
          birthday: 'Parabéns {customerName}! Hoje você faz {age} anos! 🎉 A {companyName} deseja um feliz aniversário! Você tem {totalPoints} pontos conosco.'
        }
      };
    }
  }

  // Salvar configurações de SMS da empresa
  async saveSMSSettings(companyId, settings) {
    try {
      await updateDoc(doc(db, 'companies', companyId), {
        smsSettings: settings
      });
      return true;
    } catch (error) {
      console.error('Erro ao salvar configurações de SMS:', error);
      return false;
    }
  }

  // Processar template com variáveis
  processTemplate(template, variables) {
    let processedMessage = template;
    
    // Substituir variáveis no formato {variableName}
    Object.keys(variables).forEach(key => {
      const regex = new RegExp(`{${key}}`, 'g');
      processedMessage = processedMessage.replace(regex, variables[key] || '');
    });
    
    return processedMessage;
  }

  // Enviar SMS via ClickSend
  async sendSMS(toNumber, message, smsSettings = null) {
    try {
      // Usar configurações personalizadas ou padrão
      const config = smsSettings || this.clicksendConfig;
      
      // Se as configurações personalizadas estão incompletas, usar padrão
      const finalConfig = {
        username: config.username || this.clicksendConfig.username,
        apiKey: config.apiKey || this.clicksendConfig.apiKey,
        fromName: config.fromName || this.clicksendConfig.fromName
      };
      
      if (!finalConfig.username || !finalConfig.apiKey) {
        throw new Error('Configurações do ClickSend não encontradas');
      }

      // Limpar e formatar número de telefone
      const cleanToNumber = this.formatPhoneNumber(toNumber);
      
      if (!cleanToNumber) {
        throw new Error('Número de telefone inválido');
      }

      // Preparar dados para envio no formato ClickSend
      const payload = {
        messages: [
          {
            to: cleanToNumber,
            body: message,
            from: finalConfig.fromName,
            source: "javascript"
          }
        ]
      };

      // Fazer requisição para API do ClickSend
      const response = await fetch('https://rest.clicksend.com/v3/sms/send', {
        method: 'POST',
        headers: {
          'Authorization': 'Basic ' + btoa(`${finalConfig.username}:${finalConfig.apiKey}`),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`ClickSend API Error: ${response.status} - ${errorData}`);
      }

      const result = await response.json();
      
      // Verificar se o envio foi bem-sucedido
      if (result.http_code === 200 && result.data && result.data.messages && result.data.messages.length > 0) {
        const messageResult = result.data.messages[0];
        return {
          success: messageResult.status === 'SUCCESS',
          messageId: messageResult.message_id,
          status: messageResult.status,
          cost: messageResult.message_price || 0
        };
      } else {
        throw new Error(`ClickSend Error: ${result.response_msg || 'Erro desconhecido'}`);
      }

    } catch (error) {
      console.error('Erro ao enviar SMS:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Formatar número de telefone para padrão internacional
  formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return null;
    
    // Remover todos os caracteres não numéricos
    let cleaned = phoneNumber.replace(/\D/g, '');
    
    // Se começar com 0, remover
    if (cleaned.startsWith('0')) {
      cleaned = cleaned.substring(1);
    }
    
    // Se não começar com código do país, adicionar +55 (Brasil)
    if (!cleaned.startsWith('55') && cleaned.length >= 10) {
      cleaned = '55' + cleaned;
    }
    
    // Adicionar + no início
    return '+' + cleaned;
  }

  // Enviar SMS quando pontos são adicionados
  async sendPointsAddedSMS(companyId, customer, pointsAdded, totalPoints) {
    try {
      const smsSettings = await this.getSMSSettings(companyId);
      
      if (!smsSettings || !smsSettings.enabled) {
        return { success: false, error: 'SMS não está habilitado para esta empresa' };
      }

      // Buscar dados da empresa
      const companyDoc = await getDoc(doc(db, 'companies', companyId));
      const companyData = companyDoc.exists() ? companyDoc.data() : {};

      const variables = {
        customerName: customer.name || 'Cliente',
        companyName: companyData.name || 'Nossa Empresa',
        pointsAdded: pointsAdded.toString(),
        totalPoints: totalPoints.toString()
      };

      const message = this.processTemplate(smsSettings.templates.pointsAdded, variables);
      
      return await this.sendSMS(customer.phone, message, {
        username: smsSettings.clicksendUsername,
        apiKey: smsSettings.clicksendApiKey,
        fromName: smsSettings.clicksendFromName
      });

    } catch (error) {
      console.error('Erro ao enviar SMS de pontos adicionados:', error);
      return { success: false, error: error.message };
    }
  }

  // Enviar SMS quando pontos são resgatados
  async sendPointsRedeemedSMS(companyId, customer, pointsRedeemed, totalPoints) {
    try {
      const smsSettings = await this.getSMSSettings(companyId);
      
      if (!smsSettings || !smsSettings.enabled) {
        return { success: false, error: 'SMS não está habilitado para esta empresa' };
      }

      // Buscar dados da empresa
      const companyDoc = await getDoc(doc(db, 'companies', companyId));
      const companyData = companyDoc.exists() ? companyDoc.data() : {};

      const variables = {
        customerName: customer.name || 'Cliente',
        companyName: companyData.name || 'Nossa Empresa',
        pointsRedeemed: pointsRedeemed.toString(),
        totalPoints: totalPoints.toString()
      };

      const message = this.processTemplate(smsSettings.templates.pointsRedeemed, variables);
      
      return await this.sendSMS(customer.phone, message, {
        username: smsSettings.clicksendUsername,
        apiKey: smsSettings.clicksendApiKey,
        fromName: smsSettings.clicksendFromName
      });

    } catch (error) {
      console.error('Erro ao enviar SMS de pontos resgatados:', error);
      return { success: false, error: error.message };
    }
  }

  // Enviar SMS quando prêmio é resgatado
  async sendRewardRedeemedSMS(companyId, customer, rewardName, totalPoints) {
    try {
      const smsSettings = await this.getSMSSettings(companyId);
      
      if (!smsSettings || !smsSettings.enabled) {
        return { success: false, error: 'SMS não está habilitado para esta empresa' };
      }

      // Buscar dados da empresa
      const companyDoc = await getDoc(doc(db, 'companies', companyId));
      const companyData = companyDoc.exists() ? companyDoc.data() : {};

      const variables = {
        customerName: customer.name || 'Cliente',
        companyName: companyData.name || 'Nossa Empresa',
        rewardName: rewardName || 'Prêmio',
        totalPoints: totalPoints.toString()
      };

      const message = this.processTemplate(smsSettings.templates.rewardRedeemed, variables);
      
      return await this.sendSMS(customer.phone, message, {
        username: smsSettings.clicksendUsername,
        apiKey: smsSettings.clicksendApiKey,
        fromName: smsSettings.clicksendFromName
      });

    } catch (error) {
      console.error('Erro ao enviar SMS de prêmio resgatado:', error);
      return { success: false, error: error.message };
    }
  }

  // Testar envio de SMS
  async testSMS(toNumber, message, smsSettings) {
    return await this.sendSMS(toNumber, message, smsSettings);
  }

}

export const smsService = new SMSService();
export default smsService;
